<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <div class="w-100">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <h1 class="subheader-title  mb-2 mb-lg-0">
                  <i class="subheader-icon fal fa-info"></i> Статистика по задаче <span v-if="!loading">"{{ task.name }}"</span>
                </h1>
              </div>
              <div class="col-lg-6 col-sm-12 text-lg-right text-sm-left">
                  <button v-on:click="taskEdit(task)" class="btn btn-sm btn-outline-success mr-2">
                      Изменить
                  </button>
                  <button @click="$router.go(-1)" class="btn btn-link btn-sm btn-outline-success">
                      Назад
                  </button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container show">
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div class="panel-content" v-if="!loading">
            <div class="d-flex mb-1">
              <div class="flex-grow-1">
                <ComponentWidgetStatisticsChart color="blue" :title="task.status == 'up' ? 'Работает' : 'Ошибка'" :text="task.statistics.duration"/>
                <ComponentWidgetStatisticsChart color="green" title="Время ответа" :text="task.status == 'up' && task.statistics.response > 0 ? task.statistics.response+' мс' : 'нет данных'"/>
              </div>
              <div class="d-flex flex-wrap justify-content-end align-self-start">
                <div class="d-flex">
                  <ComponentWidgetUptimeChart title="сутки" :text="task.statistics.uptime.day" :data="uptime.day"/>
                  <ComponentWidgetUptimeChart title="неделя" :text="task.statistics.uptime.week" :data="uptime.week"/>
                </div>
                <div class="d-flex">
                  <ComponentWidgetUptimeChart title="месяц" :text="task.statistics.uptime.month" :data="uptime.month"/>
                  <ComponentWidgetUptimeChart title="год" :text="task.statistics.uptime.year" :data="uptime.year"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 mb-lg-4">
                <div class="panel-tag mb-3">
                  Статистика работы за последнюю <span class="link" @click="changeUptimeChart('week')" :class="{active: uptimePeriod == 'week'}">неделю</span>, <span class="link" @click="changeUptimeChart('month')" :class="{active: uptimePeriod == 'month'}">месяц</span> или <span class="link" @click="changeUptimeChart('year')" :class="{active: uptimePeriod == 'year'}">год</span>
                </div>
                <ComponentUptimeBarChart :height="300" :labels="uptimeChartLabels" :dataset="uptimeChartData"/>
              </div>
              <div class="col-xl-6 col-lg-6">
                <div class="panel-tag mb-3">
                  Время ответа за последний <span class="link" @click="changeResponseChart('hour')" :class="{active: responsePeriod == 'hour'}">час</span>, <span class="link" @click="changeResponseChart('day')" :class="{active: responsePeriod == 'day'}">сутки</span>, <span class="link" @click="changeResponseChart('week')" :class="{active: responsePeriod == 'week'}">неделю</span> или <span class="link" @click="changeResponseChart('month')" :class="{active: responsePeriod == 'month'}">месяц</span>
                </div>
                <ComponentResponseTimeLineChart :height="300" :labels="responseChartLabels" :dataset="responseChartData" />
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="panel-tag mb-4">Последние события</div>
                <table class="table table-task-events m-0">
                  <thead>
                    <tr>
                      <th>Событие</th>
                      <th>Дата</th>
                      <th>Причина</th>
                    </tr>
                  </thead>
                  <paginate tag="tbody" name="events" :list="events" :per="10">
                    <tr v-for="event in paginated('events')" :key="event.id">
                      <th v-if="event.status == 'up'">
                        <span class="p-2 badge badge-success">
                          <i class="fal fa-long-arrow-up mr-2"></i> {{ event.status | uppercase }}
                        </span>
                      </th>
                      <th v-if="event.status == 'down'">
                        <span class="p-2 badge badge-danger">
                          <i class="fal fa-long-arrow-up mr-2"></i> {{ event.status | uppercase }}
                        </span>
                      </th>
                      <td>{{ event.date }}</td>
                      <td v-if="event.status == 'up'">
                        код ответа
                        <button class="btn btn-link p-0" v-if="event.content != ''" v-on:click="eventInfo(event)">#{{ event.code }}</button>
                        <span v-if="event.content == ''">#{{ event.code }}</span>
                      </td>
                      <td v-if="event.status == 'down'">
                        ошибка
                        <button class="btn btn-link p-0" v-on:click="eventInfo(event)">#{{ event.code }}</button>
                      </td>
                    </tr>
                  </paginate>
                  <tbody v-if="events.length == 0">
                    <tr>
                      <td colspan="4">Информации нет</td>
                    </tr>
                  </tbody>
                </table>
                <nav>
                  <paginate-links
                    for="events"
                    :hide-single-page="true"
                    :show-step-links="true"
                    :limit="3"
                    :classes="{
                      'ul': ['pagination', 'justify-content-center', 'pt-4', 'pb-0', 'mb-0'],
                      'ul > li': 'page-item',
                      'ul > li > a': 'page-link',
                    }"
                  ></paginate-links>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ComponentTasksEdit v-bind:task="editTask" v-if="editStatus" v-on:close="taskEditClose"/>
  </div>
</template>

<script>
  import Vue2Filters from 'vue2-filters';
  import { Bar } from 'vue-chartjs';
  import ComponentEventInfo from '@/components/events/information.vue';
  import ComponentWidgetStatisticsChart from '@/components/widgets/statisticsChart.vue';
  import ComponentWidgetUptimeChart from '@/components/widgets/uptimeChart.vue';
  import ComponentResponseTimeLineChart from '@/components/widgets/responseTimeLineChart.vue';
  import ComponentUptimeBarChart from '@/components/widgets/uptimeBarChart.vue';
  import ComponentTasksEdit from "@/components/tasks/edit.vue"; 
  
  export default {
    metaInfo: {
      title: 'Статистика по задаче',
    },
    components: {
      ComponentWidgetStatisticsChart,
      ComponentWidgetUptimeChart,
      ComponentResponseTimeLineChart,
      ComponentUptimeBarChart,
      ComponentTasksEdit,
    },
    data() {
      return {
        // Обновление данных
        interval: 0,
        // Статус загрузки
        loading: true,
        // Задача
        task: {},
        // Графики
        responseChartLabels: [],
        responseChartData: [],
        responsePeriod: 'hour',
        uptimeChartLabels: [],
        uptimeChartData: [],
        uptimePeriod: 'week',
        // Постраничная навигация
        paginate: ['events'],
        // Изменение задачи
        editStatus: false,
        editTask: {},
        // События по задаче
        events: [],
      }
    },
    computed: {
      uptime() {
        return {
          day:   this.task.statistics.uptime.day*100+'/10000',
          week:  this.task.statistics.uptime.week*100+'/10000',
          month: this.task.statistics.uptime.month*100+'/10000',
          year:  this.task.statistics.uptime.year*100+'/10000',
        }
      }
    },
    mixins: [Vue2Filters.mixin, Bar],
    methods: {
      eventInfo (event) {
        this.$modal.show(ComponentEventInfo, {event: event}, {minWidth: 800});
      },
      getTask()
      {
        // Получение информации по задаче
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/tasks/'+this.$route.params.id).then(response =>
        {
          this.task = response.data.data;

          // Получение данных по событиям
          this.$axios.get(process.env.VUE_APP_API_URL+'/v1/tasks/'+this.task.id+'/events').then(response =>
          {
            this.events = response.data.data;

            // Получение данных по событиям
            this.loading = false;
          });
        }).catch(function (error) {
          if (error.response) {
            if(error.response.status == 404)
              window.location.href = '/404'
          }
        });
      },
      // Изменение задачи
      taskEdit (task) 
      {
        this.editTask = {...task};
        this.editStatus = true;
      },
      // Завершение редактирования
      taskEditClose (tasksReload = false)
      {
        this.editStatus = false;
        this.editTask = {};

        // Обновление задачи при сохранении
        if(tasksReload)
        {
          // Индикатор загрузки
          this.loading = true;

          // Обновление информации по задаче
          this.getTask();
        }
      },
      // Изменение периода графика
      changeResponseChart(period)
      {
        this.responsePeriod = period;
        this.responseChart(period);
      },
      // Изменение периода графика
      changeUptimeChart(period)
      {
        this.uptimePeriod = period;
        this.responseUptime(period);
      },
      // График времени ответа
      responseChart(period)
      {
          // Получение информации по задаче
          this.$axios.post(process.env.VUE_APP_API_URL+'/v1/statistics/tasks/'+this.$route.params.id+'/response', {period: period}).then(response =>
          {
            this.responseChartLabels = Object.keys(response.data.data);
            this.responseChartData = Object.values(response.data.data);
          });
      },
      // График времени работы
      responseUptime(period)
      {
          // Получение информации по задаче
          this.$axios.post(process.env.VUE_APP_API_URL+'/v1/statistics/tasks/'+this.$route.params.id+'/uptime', {period: period}).then(response =>
          {
            this.uptimeChartLabels = Object.keys(response.data.data.up);
            this.uptimeChartData = {
              up: Object.values(response.data.data.up),
              down: Object.values(response.data.data.down),
            };
          });
      },
    },
    // Подгрузка данных
    mounted () 
    {
      this.getTask();
      this.responseChart(this.responsePeriod);
      this.responseUptime(this.uptimePeriod);
      this.interval = setInterval(function() { this.getTask(); }.bind(this), 15000);
    },
    // Остановка обновления данных
    destroyed () 
    {
      clearInterval(this.interval);
    }
  }
</script>

<style>
  td[colspan="4"] {
    text-align: center;
  }
  .link {
    color: #886ab5;
  }
  .link:hover {
    color: #967bbd;
    cursor: pointer;
  }
  .link.active {
    font-weight: bold;
  }
</style>